var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c("base-search-form", {
        attrs: {
          "form-items": _vm.orderSearchFormItems,
          "form-data": _vm.tableFrom,
        },
        on: { search: _vm.handleSearch, reset: _vm.handleSearch },
      }),
      _c("base-table", {
        ref: "table",
        staticClass: "mt20",
        attrs: {
          loading: _vm.listLoading,
          "table-data": _vm.tableData,
          columns: _vm.tableColumns,
          pagination: {
            pageNum: _vm.tableFrom.page,
            pageSize: _vm.tableFrom.limit,
          },
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.pageChange,
        },
        scopedSlots: _vm._u([
          {
            key: "nickname",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", { staticClass: "acea-row row-middle" }, [
                  _c(
                    "div",
                    { staticClass: "demo-image__preview line-heightOne mr5" },
                    [
                      _c("el-image", {
                        staticClass: "el-image",
                        attrs: {
                          src: row.avatar,
                          "preview-src-list": [row.avatar],
                          fit: "cover",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    { staticClass: "mr5", class: row.isLogoff ? "red" : "" },
                    [_vm._v(_vm._s(row.nickname || "--"))]
                  ),
                  _c("span", { staticClass: "red" }, [
                    _vm._v(" | " + _vm._s(row.uid)),
                  ]),
                  row.isLogoff
                    ? _c("span", { staticClass: "red" }, [
                        _vm._v(" | (已注销)"),
                      ])
                    : _vm._e(),
                ]),
              ]
            },
          },
          {
            key: "amount",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [_vm._v("本金：" + _vm._s(row.rechargeAmount))]),
                _c("div", [_vm._v("赠送：" + _vm._s(row.giftAmount))]),
              ]
            },
          },
          {
            key: "operate",
            fn: function (ref) {
              var row = ref.row
              return [
                _vm.checkPermi(["merchant:user:detail"])
                  ? _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.onDetails(row.id)
                          },
                        },
                      },
                      [_vm._v("用户详情")]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }